/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from '@prisma/client/runtime/index-browser'

export type * from '../models.js'
export type * from './prismaNamespace.js'

export const Decimal = runtime.Decimal

export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as new (secret: never) => typeof runtime.DbNull,
  JsonNull: runtime.NullTypes.JsonNull as new (secret: never) => typeof runtime.JsonNull,
  AnyNull: runtime.NullTypes.AnyNull as new (secret: never) => typeof runtime.AnyNull,
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull

export const ModelName = {
  Action: 'Action',
  ActionApiTrigger: 'ActionApiTrigger',
  ActionAutoTrigger: 'ActionAutoTrigger',
  ActionDatastoreVariable: 'ActionDatastoreVariable',
  ActionFrequencyTrigger: 'ActionFrequencyTrigger',
  ActionManualTrigger: 'ActionManualTrigger',
  ActionStep: 'ActionStep',
  ActionStepGroup: 'ActionStepGroup',
  ActionTriggerConcurrency: 'ActionTriggerConcurrency',
  AdminUser: 'AdminUser',
  AdminUserPermission: 'AdminUserPermission',
  AgentRun: 'AgentRun',
  Chart: 'Chart',
  ChartAggregationColumn: 'ChartAggregationColumn',
  ChartGroupBy: 'ChartGroupBy',
  ChartGroupBySort: 'ChartGroupBySort',
  Comment: 'Comment',
  ComprehensionEdge: 'ComprehensionEdge',
  Document: 'Document',
  DossbotChat: 'DossbotChat',
  DossbotChatRun: 'DossbotChatRun',
  DossbotEvent: 'DossbotEvent',
  Edge: 'Edge',
  Embed: 'Embed',
  Endpoint: 'Endpoint',
  EndpointIdempotencyKey: 'EndpointIdempotencyKey',
  EndpointVersion: 'EndpointVersion',
  EntityVersionHistory: 'EntityVersionHistory',
  EnumOption: 'EnumOption',
  EnumSet: 'EnumSet',
  Event: 'Event',
  ExecutionInstance: 'ExecutionInstance',
  Form: 'Form',
  FormBlock: 'FormBlock',
  FormCategory: 'FormCategory',
  FormField: 'FormField',
  FormFile: 'FormFile',
  FormInput: 'FormInput',
  FormInputGroup: 'FormInputGroup',
  FormLookupInputGroup: 'FormLookupInputGroup',
  FormLookupInputGroupDefaultRow: 'FormLookupInputGroupDefaultRow',
  FormPage: 'FormPage',
  FormV2: 'FormV2',
  FormValidationCondition: 'FormValidationCondition',
  FormVariant: 'FormVariant',
  FormVariantInput: 'FormVariantInput',
  FormVisibilityCondition: 'FormVisibilityCondition',
  Formula: 'Formula',
  FormulaCondition: 'FormulaCondition',
  FormulaValue: 'FormulaValue',
  GeneratedFileField: 'GeneratedFileField',
  GeneratedFileFieldMapping: 'GeneratedFileFieldMapping',
  Icon: 'Icon',
  Integration: 'Integration',
  IntegrationSync: 'IntegrationSync',
  LogicExpression: 'LogicExpression',
  LogicExpressionValue: 'LogicExpressionValue',
  LogicalBinding: 'LogicalBinding',
  LookupTableColumnGroup: 'LookupTableColumnGroup',
  ModelOption: 'ModelOption',
  ModelSpecification: 'ModelSpecification',
  NavigationItem: 'NavigationItem',
  Node: 'Node',
  Notification: 'Notification',
  ObjectStoreTableSync: 'ObjectStoreTableSync',
  Organization: 'Organization',
  OrganizationExport: 'OrganizationExport',
  Permission: 'Permission',
  Role: 'Role',
  Signature: 'Signature',
  SystemConfig: 'SystemConfig',
  SystemPrompt: 'SystemPrompt',
  Table: 'Table',
  TableButtonNode: 'TableButtonNode',
  TableButtonStateMachineConfig: 'TableButtonStateMachineConfig',
  TableButtonTransition: 'TableButtonTransition',
  TableButtonTransitionHistory: 'TableButtonTransitionHistory',
  TableColumn: 'TableColumn',
  TableColumnFilter: 'TableColumnFilter',
  TableColumnGroup: 'TableColumnGroup',
  TableColumnGroupMember: 'TableColumnGroupMember',
  TableColumnVersion: 'TableColumnVersion',
  TableExport: 'TableExport',
  TableRow: 'TableRow',
  TableSchemaVersion: 'TableSchemaVersion',
  TableTab: 'TableTab',
  TableTabColumn: 'TableTabColumn',
  TableTabSort: 'TableTabSort',
  TableUniqueConstraint: 'TableUniqueConstraint',
  TableUniqueConstraintColumn: 'TableUniqueConstraintColumn',
  ToolRunStep: 'ToolRunStep',
  TriumvirateValidationMessage: 'TriumvirateValidationMessage',
  User: 'User',
  View: 'View',
  ViewContent: 'ViewContent',
  ViewContentVersion: 'ViewContentVersion',
  Workflow: 'Workflow',
  WorkflowV2: 'WorkflowV2',
  WorkflowV2Diagnostic: 'WorkflowV2Diagnostic',
  WorkflowV2IdempotencyKey: 'WorkflowV2IdempotencyKey',
  WorkflowV2Version: 'WorkflowV2Version',
  Workspace: 'Workspace',
  WorkspaceButton: 'WorkspaceButton',
  WorkspaceChildParentEdge: 'WorkspaceChildParentEdge',
  ArchivedAction: 'ArchivedAction',
  ArchivedActionApiTrigger: 'ArchivedActionApiTrigger',
  ArchivedActionAutoTrigger: 'ArchivedActionAutoTrigger',
  ArchivedActionDatastoreVariable: 'ArchivedActionDatastoreVariable',
  ArchivedActionFrequencyTrigger: 'ArchivedActionFrequencyTrigger',
  ArchivedActionManualTrigger: 'ArchivedActionManualTrigger',
  ArchivedActionStep: 'ArchivedActionStep',
  ArchivedActionStepGroup: 'ArchivedActionStepGroup',
  ArchivedActionTriggerConcurrency: 'ArchivedActionTriggerConcurrency',
  ArchivedAgentRun: 'ArchivedAgentRun',
  ArchivedChart: 'ArchivedChart',
  ArchivedChartAggregationColumn: 'ArchivedChartAggregationColumn',
  ArchivedChartGroupBy: 'ArchivedChartGroupBy',
  ArchivedChartGroupBySort: 'ArchivedChartGroupBySort',
  ArchivedComment: 'ArchivedComment',
  ArchivedDocument: 'ArchivedDocument',
  ArchivedDossbotChat: 'ArchivedDossbotChat',
  ArchivedDossbotChatRun: 'ArchivedDossbotChatRun',
  ArchivedDossbotEvent: 'ArchivedDossbotEvent',
  ArchivedEdge: 'ArchivedEdge',
  ArchivedEmbed: 'ArchivedEmbed',
  ArchivedEndpoint: 'ArchivedEndpoint',
  ArchivedEndpointVersion: 'ArchivedEndpointVersion',
  ArchivedEntityVersionHistory: 'ArchivedEntityVersionHistory',
  ArchivedEnumOption: 'ArchivedEnumOption',
  ArchivedEnumSet: 'ArchivedEnumSet',
  ArchivedEvent: 'ArchivedEvent',
  ArchivedForm: 'ArchivedForm',
  ArchivedFormBlock: 'ArchivedFormBlock',
  ArchivedFormCategory: 'ArchivedFormCategory',
  ArchivedFormField: 'ArchivedFormField',
  ArchivedFormFile: 'ArchivedFormFile',
  ArchivedFormInput: 'ArchivedFormInput',
  ArchivedFormInputGroup: 'ArchivedFormInputGroup',
  ArchivedFormLookupInputGroup: 'ArchivedFormLookupInputGroup',
  ArchivedFormPage: 'ArchivedFormPage',
  ArchivedFormV2: 'ArchivedFormV2',
  ArchivedFormValidationCondition: 'ArchivedFormValidationCondition',
  ArchivedFormVariant: 'ArchivedFormVariant',
  ArchivedFormVariantInput: 'ArchivedFormVariantInput',
  Archived_ConditionallyVisibleFormBlocks: 'Archived_ConditionallyVisibleFormBlocks',
  ArchivedFormVisibilityCondition: 'ArchivedFormVisibilityCondition',
  ArchivedFormula: 'ArchivedFormula',
  ArchivedFormulaCondition: 'ArchivedFormulaCondition',
  ArchivedFormulaValue: 'ArchivedFormulaValue',
  ArchivedGeneratedFileField: 'ArchivedGeneratedFileField',
  ArchivedGeneratedFileFieldMapping: 'ArchivedGeneratedFileFieldMapping',
  ArchivedIcon: 'ArchivedIcon',
  ArchivedIntegration: 'ArchivedIntegration',
  ArchivedIntegrationSync: 'ArchivedIntegrationSync',
  ArchivedLogicExpression: 'ArchivedLogicExpression',
  ArchivedLogicExpressionValue: 'ArchivedLogicExpressionValue',
  ArchivedLookupTableColumnGroup: 'ArchivedLookupTableColumnGroup',
  ArchivedModelOption: 'ArchivedModelOption',
  ArchivedModelSpecification: 'ArchivedModelSpecification',
  ArchivedNavigationItem: 'ArchivedNavigationItem',
  ArchivedNode: 'ArchivedNode',
  ArchivedNotification: 'ArchivedNotification',
  ArchivedObjectStoreTableSync: 'ArchivedObjectStoreTableSync',
  ArchivedOrganization: 'ArchivedOrganization',
  ArchivedPermission: 'ArchivedPermission',
  Archived_UserRoles: 'Archived_UserRoles',
  ArchivedRole: 'ArchivedRole',
  ArchivedSignature: 'ArchivedSignature',
  ArchivedSystemPrompt: 'ArchivedSystemPrompt',
  ArchivedTable: 'ArchivedTable',
  ArchivedTableButtonNode: 'ArchivedTableButtonNode',
  ArchivedTableButtonStateMachineConfig: 'ArchivedTableButtonStateMachineConfig',
  ArchivedTableButtonTransition: 'ArchivedTableButtonTransition',
  ArchivedTableButtonTransitionHistory: 'ArchivedTableButtonTransitionHistory',
  ArchivedTableColumn: 'ArchivedTableColumn',
  ArchivedTableColumnFilter: 'ArchivedTableColumnFilter',
  ArchivedTableColumnGroup: 'ArchivedTableColumnGroup',
  ArchivedTableColumnGroupMember: 'ArchivedTableColumnGroupMember',
  Archived_RowCurrentButtonNodes: 'Archived_RowCurrentButtonNodes',
  Archived_RowPendingButtonNodes: 'Archived_RowPendingButtonNodes',
  ArchivedTableRow: 'ArchivedTableRow',
  ArchivedTableTab: 'ArchivedTableTab',
  ArchivedTableTabColumn: 'ArchivedTableTabColumn',
  ArchivedTableTabSort: 'ArchivedTableTabSort',
  ArchivedTableUniqueConstraint: 'ArchivedTableUniqueConstraint',
  ArchivedTableUniqueConstraintColumn: 'ArchivedTableUniqueConstraintColumn',
  ArchivedToolRunStep: 'ArchivedToolRunStep',
  ArchivedUser: 'ArchivedUser',
  ArchivedView: 'ArchivedView',
  ArchivedViewContent: 'ArchivedViewContent',
  ArchivedViewContentVersion: 'ArchivedViewContentVersion',
  ArchivedWorkflow: 'ArchivedWorkflow',
  ArchivedWorkflowV2: 'ArchivedWorkflowV2',
  ArchivedWorkflowV2Diagnostic: 'ArchivedWorkflowV2Diagnostic',
  ArchivedWorkflowV2Version: 'ArchivedWorkflowV2Version',
  ArchivedWorkspace: 'ArchivedWorkspace',
  ArchivedWorkspaceButton: 'ArchivedWorkspaceButton',
  ArchivedWorkspaceChildParentEdge: 'ArchivedWorkspaceChildParentEdge',
  ActionFrequencyScheduleReconciliation: 'ActionFrequencyScheduleReconciliation',
  IntegrationCredential: 'IntegrationCredential',
  OrganizationApiKey: 'OrganizationApiKey',
  AdminOAuth2Token: 'AdminOAuth2Token',
  AppOAuth2Token: 'AppOAuth2Token',
  RestatePausedInvocation: 'RestatePausedInvocation',
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable',
} as const)

export type TransactionIsolationLevel =
  (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]

export const ActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  alertSlack: 'alertSlack',
  description: 'description',
  featureFlags: 'featureFlags',
  name: 'name',
  order: 'order',
  showNotification: 'showNotification',
  slug: 'slug',
  status: 'status',
  workflowId: 'workflowId',
} as const

export type ActionScalarFieldEnum =
  (typeof ActionScalarFieldEnum)[keyof typeof ActionScalarFieldEnum]

export const ActionApiTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  organizationId: 'organizationId',
  requestSchema: 'requestSchema',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
} as const

export type ActionApiTriggerScalarFieldEnum =
  (typeof ActionApiTriggerScalarFieldEnum)[keyof typeof ActionApiTriggerScalarFieldEnum]

export const ActionAutoTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  filterExpression: 'filterExpression',
  logoId: 'logoId',
  organizationId: 'organizationId',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  triggerMetadata: 'triggerMetadata',
  type: 'type',
  workflowV2Id: 'workflowV2Id',
} as const

export type ActionAutoTriggerScalarFieldEnum =
  (typeof ActionAutoTriggerScalarFieldEnum)[keyof typeof ActionAutoTriggerScalarFieldEnum]

export const ActionDatastoreVariableScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  defaultValue: 'defaultValue',
  description: 'description',
  name: 'name',
  type: 'type',
} as const

export type ActionDatastoreVariableScalarFieldEnum =
  (typeof ActionDatastoreVariableScalarFieldEnum)[keyof typeof ActionDatastoreVariableScalarFieldEnum]

export const ActionFrequencyTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  daysOfWeek: 'daysOfWeek',
  hoursOfDay: 'hoursOfDay',
  organizationId: 'organizationId',
  repeatNumber: 'repeatNumber',
  repeatUnit: 'repeatUnit',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  startAt: 'startAt',
  workflowV2Id: 'workflowV2Id',
} as const

export type ActionFrequencyTriggerScalarFieldEnum =
  (typeof ActionFrequencyTriggerScalarFieldEnum)[keyof typeof ActionFrequencyTriggerScalarFieldEnum]

export const ActionManualTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  name: 'name',
  organizationId: 'organizationId',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  workflowV2Id: 'workflowV2Id',
} as const

export type ActionManualTriggerScalarFieldEnum =
  (typeof ActionManualTriggerScalarFieldEnum)[keyof typeof ActionManualTriggerScalarFieldEnum]

export const ActionStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  actionStepGroupId: 'actionStepGroupId',
  description: 'description',
  inactiveReason: 'inactiveReason',
  integrationId: 'integrationId',
  integrationIdMapping: 'integrationIdMapping',
  logoId: 'logoId',
  name: 'name',
  oldSelectionsData: 'oldSelectionsData',
  order: 'order',
  outputSchema: 'outputSchema',
  rootActionId: 'rootActionId',
  selectionsData: 'selectionsData',
  slug: 'slug',
  status: 'status',
  type: 'type',
} as const

export type ActionStepScalarFieldEnum =
  (typeof ActionStepScalarFieldEnum)[keyof typeof ActionStepScalarFieldEnum]

export const ActionStepGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  order: 'order',
  parentActionStepId: 'parentActionStepId',
  rootActionId: 'rootActionId',
  slug: 'slug',
} as const

export type ActionStepGroupScalarFieldEnum =
  (typeof ActionStepGroupScalarFieldEnum)[keyof typeof ActionStepGroupScalarFieldEnum]

export const ActionTriggerConcurrencyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionAutoTriggerId: 'actionAutoTriggerId',
  actionFrequencyTriggerId: 'actionFrequencyTriggerId',
  actionManualTriggerId: 'actionManualTriggerId',
  keyExpressions: 'keyExpressions',
  mode: 'mode',
  scope: 'scope',
} as const

export type ActionTriggerConcurrencyScalarFieldEnum =
  (typeof ActionTriggerConcurrencyScalarFieldEnum)[keyof typeof ActionTriggerConcurrencyScalarFieldEnum]

export const AdminUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  externalUserId: 'externalUserId',
  firebaseUid: 'firebaseUid',
  invitedByAdminUserId: 'invitedByAdminUserId',
  status: 'status',
} as const

export type AdminUserScalarFieldEnum =
  (typeof AdminUserScalarFieldEnum)[keyof typeof AdminUserScalarFieldEnum]

export const AdminUserPermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  adminUserId: 'adminUserId',
  permission: 'permission',
} as const

export type AdminUserPermissionScalarFieldEnum =
  (typeof AdminUserPermissionScalarFieldEnum)[keyof typeof AdminUserPermissionScalarFieldEnum]

export const AgentRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  dossbotChatRunId: 'dossbotChatRunId',
  input: 'input',
  modelSpecId: 'modelSpecId',
  status: 'status',
  summary: 'summary',
  systemPromptId: 'systemPromptId',
  tokenUsage: 'tokenUsage',
} as const

export type AgentRunScalarFieldEnum =
  (typeof AgentRunScalarFieldEnum)[keyof typeof AgentRunScalarFieldEnum]

export const ChartScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aggregationOperation: 'aggregationOperation',
  chartType: 'chartType',
  filtersBooleanOperator: 'filtersBooleanOperator',
  name: 'name',
  organizationId: 'organizationId',
  rootWorkspaceId: 'rootWorkspaceId',
  slug: 'slug',
  styling: 'styling',
  tableId: 'tableId',
  thresholds: 'thresholds',
  xAxisId: 'xAxisId',
  yAxisId: 'yAxisId',
} as const

export type ChartScalarFieldEnum = (typeof ChartScalarFieldEnum)[keyof typeof ChartScalarFieldEnum]

export const ChartAggregationColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aggregationOperation: 'aggregationOperation',
  chartId: 'chartId',
  order: 'order',
  tableColumnId: 'tableColumnId',
  valueDisplayType: 'valueDisplayType',
} as const

export type ChartAggregationColumnScalarFieldEnum =
  (typeof ChartAggregationColumnScalarFieldEnum)[keyof typeof ChartAggregationColumnScalarFieldEnum]

export const ChartGroupByScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chartId: 'chartId',
  metadata: 'metadata',
  tableColumnId: 'tableColumnId',
  type: 'type',
} as const

export type ChartGroupByScalarFieldEnum =
  (typeof ChartGroupByScalarFieldEnum)[keyof typeof ChartGroupByScalarFieldEnum]

export const ChartGroupBySortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aggregationColumnId: 'aggregationColumnId',
  direction: 'direction',
  groupById: 'groupById',
  sortType: 'sortType',
} as const

export type ChartGroupBySortScalarFieldEnum =
  (typeof ChartGroupBySortScalarFieldEnum)[keyof typeof ChartGroupBySortScalarFieldEnum]

export const CommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorId: 'authorId',
  parentCommentId: 'parentCommentId',
  text: 'text',
  workspaceId: 'workspaceId',
} as const

export type CommentScalarFieldEnum =
  (typeof CommentScalarFieldEnum)[keyof typeof CommentScalarFieldEnum]

export const ComprehensionEdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  edgeType: 'edgeType',
  fromEntityId: 'fromEntityId',
  fromEntityType: 'fromEntityType',
  metadata: 'metadata',
  organizationId: 'organizationId',
  relationshipKey: 'relationshipKey',
  rootActionId: 'rootActionId',
  toEntityId: 'toEntityId',
  toEntityType: 'toEntityType',
} as const

export type ComprehensionEdgeScalarFieldEnum =
  (typeof ComprehensionEdgeScalarFieldEnum)[keyof typeof ComprehensionEdgeScalarFieldEnum]

export const DocumentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contentSha256: 'contentSha256',
  contentSizeBytes: 'contentSizeBytes',
  createdById: 'createdById',
  documentType: 'documentType',
  markForDeletionAt: 'markForDeletionAt',
  name: 'name',
  organizationId: 'organizationId',
  rootWorkspaceId: 'rootWorkspaceId',
  storagePath: 'storagePath',
  updatedById: 'updatedById',
} as const

export type DocumentScalarFieldEnum =
  (typeof DocumentScalarFieldEnum)[keyof typeof DocumentScalarFieldEnum]

export const DossbotChatScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  summary: 'summary',
  title: 'title',
} as const

export type DossbotChatScalarFieldEnum =
  (typeof DossbotChatScalarFieldEnum)[keyof typeof DossbotChatScalarFieldEnum]

export const DossbotChatRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chatId: 'chatId',
  completedAt: 'completedAt',
  inputPrompt: 'inputPrompt',
  response: 'response',
  status: 'status',
} as const

export type DossbotChatRunScalarFieldEnum =
  (typeof DossbotChatRunScalarFieldEnum)[keyof typeof DossbotChatRunScalarFieldEnum]

export const DossbotEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agentRunId: 'agentRunId',
  chatId: 'chatId',
  chatRunId: 'chatRunId',
  payload: 'payload',
  toolRunStepId: 'toolRunStepId',
  type: 'type',
} as const

export type DossbotEventScalarFieldEnum =
  (typeof DossbotEventScalarFieldEnum)[keyof typeof DossbotEventScalarFieldEnum]

export const EdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sourceNodeId: 'sourceNodeId',
  targetNodeId: 'targetNodeId',
} as const

export type EdgeScalarFieldEnum = (typeof EdgeScalarFieldEnum)[keyof typeof EdgeScalarFieldEnum]

export const EmbedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  betaWatermarkDisabled: 'betaWatermarkDisabled',
  name: 'name',
  organizationId: 'organizationId',
  viewContentId: 'viewContentId',
} as const

export type EmbedScalarFieldEnum = (typeof EmbedScalarFieldEnum)[keyof typeof EmbedScalarFieldEnum]

export const EndpointScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  internal: 'internal',
  latestVersionId: 'latestVersionId',
  organizationId: 'organizationId',
  slug: 'slug',
} as const

export type EndpointScalarFieldEnum =
  (typeof EndpointScalarFieldEnum)[keyof typeof EndpointScalarFieldEnum]

export const EndpointIdempotencyKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  claimId: 'claimId',
  contentHash: 'contentHash',
  endpointId: 'endpointId',
  expiresAt: 'expiresAt',
  inputHash: 'inputHash',
  key: 'key',
  output: 'output',
  status: 'status',
} as const

export type EndpointIdempotencyKeyScalarFieldEnum =
  (typeof EndpointIdempotencyKeyScalarFieldEnum)[keyof typeof EndpointIdempotencyKeyScalarFieldEnum]

export const EndpointVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  compilerVersion: 'compilerVersion',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  endpointId: 'endpointId',
  engineVersion: 'engineVersion',
  idempotency: 'idempotency',
  input: 'input',
  manifest: 'manifest',
  mappings: 'mappings',
  mappingsHash: 'mappingsHash',
  output: 'output',
  shimHash: 'shimHash',
  shimVersion: 'shimVersion',
  sourceMapHash: 'sourceMapHash',
  version: 'version',
} as const

export type EndpointVersionScalarFieldEnum =
  (typeof EndpointVersionScalarFieldEnum)[keyof typeof EndpointVersionScalarFieldEnum]

export const EntityVersionHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  comment: 'comment',
  entityType: 'entityType',
  formV2Id: 'formV2Id',
  jsonSnapshot: 'jsonSnapshot',
  modifiedBy: 'modifiedBy',
  tableId: 'tableId',
} as const

export type EntityVersionHistoryScalarFieldEnum =
  (typeof EntityVersionHistoryScalarFieldEnum)[keyof typeof EntityVersionHistoryScalarFieldEnum]

export const EnumOptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  colorCustom: 'colorCustom',
  colorPreset: 'colorPreset',
  enumSetId: 'enumSetId',
  iconId: 'iconId',
  label: 'label',
  order: 'order',
} as const

export type EnumOptionScalarFieldEnum =
  (typeof EnumOptionScalarFieldEnum)[keyof typeof EnumOptionScalarFieldEnum]

export const EnumSetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
} as const

export type EnumSetScalarFieldEnum =
  (typeof EnumSetScalarFieldEnum)[keyof typeof EnumSetScalarFieldEnum]

export const EventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  data: 'data',
  type: 'type',
  workspaceId: 'workspaceId',
} as const

export type EventScalarFieldEnum = (typeof EventScalarFieldEnum)[keyof typeof EventScalarFieldEnum]

export const ExecutionInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  actionStepId: 'actionStepId',
  actionStepGroupId: 'actionStepGroupId',
  actionVersionId: 'actionVersionId',
  apiTriggerId: 'apiTriggerId',
  archivedActionId: 'archivedActionId',
  archivedActionStepGroupId: 'archivedActionStepGroupId',
  archivedActionStepId: 'archivedActionStepId',
  attemptNumber: 'attemptNumber',
  autoTriggerId: 'autoTriggerId',
  bullQueue: 'bullQueue',
  completedAt: 'completedAt',
  frequencyTriggerId: 'frequencyTriggerId',
  jobId: 'jobId',
  manualTriggerId: 'manualTriggerId',
  parentExecutionInstanceId: 'parentExecutionInstanceId',
  priority: 'priority',
  startedAt: 'startedAt',
  status: 'status',
  type: 'type',
} as const

export type ExecutionInstanceScalarFieldEnum =
  (typeof ExecutionInstanceScalarFieldEnum)[keyof typeof ExecutionInstanceScalarFieldEnum]

export const FormScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isShareable: 'isShareable',
  name: 'name',
  organizationId: 'organizationId',
  redirectCustomPath: 'redirectCustomPath',
  redirectTarget: 'redirectTarget',
  slug: 'slug',
} as const

export type FormScalarFieldEnum = (typeof FormScalarFieldEnum)[keyof typeof FormScalarFieldEnum]

export const FormBlockScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formId: 'formId',
  inputId: 'inputId',
  inputGroupId: 'inputGroupId',
  metadata: 'metadata',
  order: 'order',
  parentBlockId: 'parentBlockId',
  type: 'type',
} as const

export type FormBlockScalarFieldEnum =
  (typeof FormBlockScalarFieldEnum)[keyof typeof FormBlockScalarFieldEnum]

export const FormCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  allowFillAll: 'allowFillAll',
  formId: 'formId',
  isArray: 'isArray',
  lookupTableId: 'lookupTableId',
  name: 'name',
  order: 'order',
  pageId: 'pageId',
  slug: 'slug',
} as const

export type FormCategoryScalarFieldEnum =
  (typeof FormCategoryScalarFieldEnum)[keyof typeof FormCategoryScalarFieldEnum]

export const FormFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  categoryId: 'categoryId',
  defaultValue: 'defaultValue',
  description: 'description',
  displayImagesInline: 'displayImagesInline',
  fieldOptions: 'fieldOptions',
  formId: 'formId',
  isArray: 'isArray',
  isEditable: 'isEditable',
  isFrozen: 'isFrozen',
  isRequired: 'isRequired',
  isVisible: 'isVisible',
  lookupColumnId: 'lookupColumnId',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  metadata: 'metadata',
  name: 'name',
  order: 'order',
  slug: 'slug',
  type: 'type',
} as const

export type FormFieldScalarFieldEnum =
  (typeof FormFieldScalarFieldEnum)[keyof typeof FormFieldScalarFieldEnum]

export const FormFileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formId: 'formId',
  formCategoryId: 'formCategoryId',
  nameFieldId: 'nameFieldId',
  type: 'type',
} as const

export type FormFileScalarFieldEnum =
  (typeof FormFileScalarFieldEnum)[keyof typeof FormFileScalarFieldEnum]

export const FormInputScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dataType: 'dataType',
  defaultValue: 'defaultValue',
  description: 'description',
  formId: 'formId',
  formatOptions: 'formatOptions',
  formatPreset: 'formatPreset',
  formulaId: 'formulaId',
  groupId: 'groupId',
  indexDataType: 'indexDataType',
  innerDataType: 'innerDataType',
  inputType: 'inputType',
  isFrozen: 'isFrozen',
  isReadOnly: 'isReadOnly',
  isRequired: 'isRequired',
  isVisible: 'isVisible',
  label: 'label',
  lookupGroupId: 'lookupGroupId',
  lookupTableColumnId: 'lookupTableColumnId',
  metadata: 'metadata',
  slug: 'slug',
  sourceTableColumnId: 'sourceTableColumnId',
} as const

export type FormInputScalarFieldEnum =
  (typeof FormInputScalarFieldEnum)[keyof typeof FormInputScalarFieldEnum]

export const FormInputGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formId: 'formId',
  label: 'label',
  slug: 'slug',
} as const

export type FormInputGroupScalarFieldEnum =
  (typeof FormInputGroupScalarFieldEnum)[keyof typeof FormInputGroupScalarFieldEnum]

export const FormLookupInputGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formId: 'formId',
  isAutoFill: 'isAutoFill',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  lookupTableId: 'lookupTableId',
} as const

export type FormLookupInputGroupScalarFieldEnum =
  (typeof FormLookupInputGroupScalarFieldEnum)[keyof typeof FormLookupInputGroupScalarFieldEnum]

export const FormLookupInputGroupDefaultRowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lookupInputGroupId: 'lookupInputGroupId',
  tableRowId: 'tableRowId',
} as const

export type FormLookupInputGroupDefaultRowScalarFieldEnum =
  (typeof FormLookupInputGroupDefaultRowScalarFieldEnum)[keyof typeof FormLookupInputGroupDefaultRowScalarFieldEnum]

export const FormPageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formId: 'formId',
  name: 'name',
  order: 'order',
  slug: 'slug',
} as const

export type FormPageScalarFieldEnum =
  (typeof FormPageScalarFieldEnum)[keyof typeof FormPageScalarFieldEnum]

export const FormV2ScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  linkedTableId: 'linkedTableId',
  name: 'name',
  organizationId: 'organizationId',
  redirectCustomPath: 'redirectCustomPath',
  redirectTarget: 'redirectTarget',
  slug: 'slug',
  sourceFormId: 'sourceFormId',
} as const

export type FormV2ScalarFieldEnum =
  (typeof FormV2ScalarFieldEnum)[keyof typeof FormV2ScalarFieldEnum]

export const FormValidationConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conditionExpressionId: 'conditionExpressionId',
  inputAppliedToId: 'inputAppliedToId',
  validationMessage: 'validationMessage',
} as const

export type FormValidationConditionScalarFieldEnum =
  (typeof FormValidationConditionScalarFieldEnum)[keyof typeof FormValidationConditionScalarFieldEnum]

export const FormVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  formId: 'formId',
  name: 'name',
} as const

export type FormVariantScalarFieldEnum =
  (typeof FormVariantScalarFieldEnum)[keyof typeof FormVariantScalarFieldEnum]

export const FormVariantInputScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  defaultValue: 'defaultValue',
  inputId: 'inputId',
  isReadOnly: 'isReadOnly',
  variantId: 'variantId',
} as const

export type FormVariantInputScalarFieldEnum =
  (typeof FormVariantInputScalarFieldEnum)[keyof typeof FormVariantInputScalarFieldEnum]

export const FormVisibilityConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expressionId: 'expressionId',
  formV2Id: 'formV2Id',
  name: 'name',
  slug: 'slug',
} as const

export type FormVisibilityConditionScalarFieldEnum =
  (typeof FormVisibilityConditionScalarFieldEnum)[keyof typeof FormVisibilityConditionScalarFieldEnum]

export const FormulaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  columnOperationFilterId: 'columnOperationFilterId',
  formulaString: 'formulaString',
  operator: 'operator',
  organizationId: 'organizationId',
  outputType: 'outputType',
} as const

export type FormulaScalarFieldEnum =
  (typeof FormulaScalarFieldEnum)[keyof typeof FormulaScalarFieldEnum]

export const FormulaConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conditionExpressionId: 'conditionExpressionId',
  formulaId: 'formulaId',
  order: 'order',
  parentFormulaValueId: 'parentFormulaValueId',
} as const

export type FormulaConditionScalarFieldEnum =
  (typeof FormulaConditionScalarFieldEnum)[keyof typeof FormulaConditionScalarFieldEnum]

export const FormulaValueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  formInputId: 'formInputId',
  formulaId: 'formulaId',
  order: 'order',
  parentFormulaId: 'parentFormulaId',
  tableColumnId: 'tableColumnId',
  valueBoolean: 'valueBoolean',
  valueDate: 'valueDate',
  valueDateTime: 'valueDateTime',
  valueNumber: 'valueNumber',
  valueString: 'valueString',
} as const

export type FormulaValueScalarFieldEnum =
  (typeof FormulaValueScalarFieldEnum)[keyof typeof FormulaValueScalarFieldEnum]

export const GeneratedFileFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fieldName: 'fieldName',
  type: 'type',
} as const

export type GeneratedFileFieldScalarFieldEnum =
  (typeof GeneratedFileFieldScalarFieldEnum)[keyof typeof GeneratedFileFieldScalarFieldEnum]

export const GeneratedFileFieldMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fileFieldId: 'fileFieldId',
  formFieldId: 'formFieldId',
  formFileId: 'formFileId',
} as const

export type GeneratedFileFieldMappingScalarFieldEnum =
  (typeof GeneratedFileFieldMappingScalarFieldEnum)[keyof typeof GeneratedFileFieldMappingScalarFieldEnum]

export const IconScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
} as const

export type IconScalarFieldEnum = (typeof IconScalarFieldEnum)[keyof typeof IconScalarFieldEnum]

export const IntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metadata: 'metadata',
  organizationId: 'organizationId',
  slug: 'slug',
  type: 'type',
  userId: 'userId',
} as const

export type IntegrationScalarFieldEnum =
  (typeof IntegrationScalarFieldEnum)[keyof typeof IntegrationScalarFieldEnum]

export const IntegrationSyncScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  integrationId: 'integrationId',
  metadata: 'metadata',
  status: 'status',
} as const

export type IntegrationSyncScalarFieldEnum =
  (typeof IntegrationSyncScalarFieldEnum)[keyof typeof IntegrationSyncScalarFieldEnum]

export const LogicExpressionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  condition: 'condition',
  logicExpressionString: 'logicExpressionString',
  type: 'type',
} as const

export type LogicExpressionScalarFieldEnum =
  (typeof LogicExpressionScalarFieldEnum)[keyof typeof LogicExpressionScalarFieldEnum]

export const LogicExpressionValueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  columnId: 'columnId',
  formFieldId: 'formFieldId',
  formInputId: 'formInputId',
  formulaId: 'formulaId',
  nestedExpressionId: 'nestedExpressionId',
  order: 'order',
  parentExpressionId: 'parentExpressionId',
  value: 'value',
} as const

export type LogicExpressionValueScalarFieldEnum =
  (typeof LogicExpressionValueScalarFieldEnum)[keyof typeof LogicExpressionValueScalarFieldEnum]

export const LogicalBindingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityKind: 'entityKind',
  localId: 'localId',
  organizationId: 'organizationId',
  parentId: 'parentId',
  physicalId: 'physicalId',
  provenance: 'provenance',
} as const

export type LogicalBindingScalarFieldEnum =
  (typeof LogicalBindingScalarFieldEnum)[keyof typeof LogicalBindingScalarFieldEnum]

export const LookupTableColumnGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  backlinkName: 'backlinkName',
  lookupTableId: 'lookupTableId',
  showBacklink: 'showBacklink',
  slug: 'slug',
} as const

export type LookupTableColumnGroupScalarFieldEnum =
  (typeof LookupTableColumnGroupScalarFieldEnum)[keyof typeof LookupTableColumnGroupScalarFieldEnum]

export const ModelOptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cacheReadUsdPerMtok: 'cacheReadUsdPerMtok',
  cacheWriteUsdPerMtok: 'cacheWriteUsdPerMtok',
  inputUsdPerMtok: 'inputUsdPerMtok',
  modelName: 'modelName',
  outputUsdPerMtok: 'outputUsdPerMtok',
  provider: 'provider',
} as const

export type ModelOptionScalarFieldEnum =
  (typeof ModelOptionScalarFieldEnum)[keyof typeof ModelOptionScalarFieldEnum]

export const ModelSpecificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  maxSteps: 'maxSteps',
  modelId: 'modelId',
  name: 'name',
} as const

export type ModelSpecificationScalarFieldEnum =
  (typeof ModelSpecificationScalarFieldEnum)[keyof typeof ModelSpecificationScalarFieldEnum]

export const NavigationItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  destinationId: 'destinationId',
  destinationType: 'destinationType',
  icon: 'icon',
  label: 'label',
  link: 'link',
  order: 'order',
  organizationId: 'organizationId',
  parentItemId: 'parentItemId',
} as const

export type NavigationItemScalarFieldEnum =
  (typeof NavigationItemScalarFieldEnum)[keyof typeof NavigationItemScalarFieldEnum]

export const NodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sourceId: 'sourceId',
  sourceType: 'sourceType',
} as const

export type NodeScalarFieldEnum = (typeof NodeScalarFieldEnum)[keyof typeof NodeScalarFieldEnum]

export const NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  commentId: 'commentId',
  isArchived: 'isArchived',
  isRead: 'isRead',
  metadata: 'metadata',
  notificationType: 'notificationType',
  userId: 'userId',
} as const

export type NotificationScalarFieldEnum =
  (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]

export const ObjectStoreTableSyncScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  daysOfWeek: 'daysOfWeek',
  direction: 'direction',
  filePattern: 'filePattern',
  fileType: 'fileType',
  ignoreMissingColumns: 'ignoreMissingColumns',
  integrationId: 'integrationId',
  repeatNumber: 'repeatNumber',
  repeatUnit: 'repeatUnit',
  startAt: 'startAt',
  tableId: 'tableId',
} as const

export type ObjectStoreTableSyncScalarFieldEnum =
  (typeof ObjectStoreTableSyncScalarFieldEnum)[keyof typeof ObjectStoreTableSyncScalarFieldEnum]

export const OrganizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  currency: 'currency',
  featureFlags: 'featureFlags',
  locale: 'locale',
  logoId: 'logoId',
  name: 'name',
  navigationConfigbaseHash: 'navigationConfigbaseHash',
  parentOrganizationId: 'parentOrganizationId',
  slug: 'slug',
  startOfFiscalYearMonth: 'startOfFiscalYearMonth',
  startOfWeekDay: 'startOfWeekDay',
  status: 'status',
  timeZone: 'timeZone',
  version: 'version',
} as const

export type OrganizationScalarFieldEnum =
  (typeof OrganizationScalarFieldEnum)[keyof typeof OrganizationScalarFieldEnum]

export const OrganizationExportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  backend: 'backend',
  createdById: 'createdById',
  documentId: 'documentId',
  errorMessage: 'errorMessage',
  organizationId: 'organizationId',
  status: 'status',
  totalTableCount: 'totalTableCount',
} as const

export type OrganizationExportScalarFieldEnum =
  (typeof OrganizationExportScalarFieldEnum)[keyof typeof OrganizationExportScalarFieldEnum]

export const PermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  embedId: 'embedId',
  endpointId: 'endpointId',
  formId: 'formId',
  formV2Id: 'formV2Id',
  manualTriggerId: 'manualTriggerId',
  objectType: 'objectType',
  permissionType: 'permissionType',
  roleId: 'roleId',
  tableId: 'tableId',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
  workspaceId: 'workspaceId',
} as const

export type PermissionScalarFieldEnum =
  (typeof PermissionScalarFieldEnum)[keyof typeof PermissionScalarFieldEnum]

export const RoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  organizationId: 'organizationId',
  roleType: 'roleType',
  slug: 'slug',
} as const

export type RoleScalarFieldEnum = (typeof RoleScalarFieldEnum)[keyof typeof RoleScalarFieldEnum]

export const SignatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  signatureFileId: 'signatureFileId',
  userId: 'userId',
} as const

export type SignatureScalarFieldEnum =
  (typeof SignatureScalarFieldEnum)[keyof typeof SignatureScalarFieldEnum]

export const SystemConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  scopeId: 'scopeId',
  scopeType: 'scopeType',
  value: 'value',
} as const

export type SystemConfigScalarFieldEnum =
  (typeof SystemConfigScalarFieldEnum)[keyof typeof SystemConfigScalarFieldEnum]

export const SystemPromptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  modelSpecId: 'modelSpecId',
  prompt: 'prompt',
  version: 'version',
} as const

export type SystemPromptScalarFieldEnum =
  (typeof SystemPromptScalarFieldEnum)[keyof typeof SystemPromptScalarFieldEnum]

export const TableScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  iconId: 'iconId',
  name: 'name',
  orderOnRecordDetails: 'orderOnRecordDetails',
  organizationId: 'organizationId',
  parentTableId: 'parentTableId',
  rootWorkspaceId: 'rootWorkspaceId',
  showRowWorkspace: 'showRowWorkspace',
  slug: 'slug',
} as const

export type TableScalarFieldEnum = (typeof TableScalarFieldEnum)[keyof typeof TableScalarFieldEnum]

export const TableButtonNodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  tableId: 'tableId',
} as const

export type TableButtonNodeScalarFieldEnum =
  (typeof TableButtonNodeScalarFieldEnum)[keyof typeof TableButtonNodeScalarFieldEnum]

export const TableButtonStateMachineConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rootButtonNodeId: 'rootButtonNodeId',
  tableId: 'tableId',
} as const

export type TableButtonStateMachineConfigScalarFieldEnum =
  (typeof TableButtonStateMachineConfigScalarFieldEnum)[keyof typeof TableButtonStateMachineConfigScalarFieldEnum]

export const TableButtonTransitionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conditionId: 'conditionId',
  name: 'name',
  sourceNodeId: 'sourceNodeId',
  targetNodeId: 'targetNodeId',
} as const

export type TableButtonTransitionScalarFieldEnum =
  (typeof TableButtonTransitionScalarFieldEnum)[keyof typeof TableButtonTransitionScalarFieldEnum]

export const TableButtonTransitionHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  fromNodeId: 'fromNodeId',
  fromNodeName: 'fromNodeName',
  logicExpressionString: 'logicExpressionString',
  tableRowId: 'tableRowId',
  toNodeId: 'toNodeId',
  toNodeName: 'toNodeName',
  transitionId: 'transitionId',
  userId: 'userId',
} as const

export type TableButtonTransitionHistoryScalarFieldEnum =
  (typeof TableButtonTransitionHistoryScalarFieldEnum)[keyof typeof TableButtonTransitionHistoryScalarFieldEnum]

export const TableColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  displayImagesInline: 'displayImagesInline',
  enumOptions: 'enumOptions',
  enumSetId: 'enumSetId',
  formatOptions: 'formatOptions',
  formatPreset: 'formatPreset',
  formulaId: 'formulaId',
  indexAutogenerate: 'indexAutogenerate',
  indexPrefix: 'indexPrefix',
  indexSuffix: 'indexSuffix',
  indexType: 'indexType',
  innerType: 'innerType',
  isDecimal: 'isDecimal',
  isNullable: 'isNullable',
  isReadOnly: 'isReadOnly',
  isVisibleOnRecordDetails: 'isVisibleOnRecordDetails',
  lookupColumnId: 'lookupColumnId',
  lookupColumnGroupId: 'lookupColumnGroupId',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  name: 'name',
  order: 'order',
  slug: 'slug',
  tableId: 'tableId',
  type: 'type',
} as const

export type TableColumnScalarFieldEnum =
  (typeof TableColumnScalarFieldEnum)[keyof typeof TableColumnScalarFieldEnum]

export const TableColumnFilterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chartId: 'chartId',
  filterableObjectType: 'filterableObjectType',
  operand: 'operand',
  operator: 'operator',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type TableColumnFilterScalarFieldEnum =
  (typeof TableColumnFilterScalarFieldEnum)[keyof typeof TableColumnFilterScalarFieldEnum]

export const TableColumnGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  order: 'order',
  tableId: 'tableId',
} as const

export type TableColumnGroupScalarFieldEnum =
  (typeof TableColumnGroupScalarFieldEnum)[keyof typeof TableColumnGroupScalarFieldEnum]

export const TableColumnGroupMemberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  order: 'order',
  tableColumnId: 'tableColumnId',
  tableColumnGroupId: 'tableColumnGroupId',
} as const

export type TableColumnGroupMemberScalarFieldEnum =
  (typeof TableColumnGroupMemberScalarFieldEnum)[keyof typeof TableColumnGroupMemberScalarFieldEnum]

export const TableColumnVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activatedAt: 'activatedAt',
  backfillValue: 'backfillValue',
  dataType: 'dataType',
  deactivatedAt: 'deactivatedAt',
  indexType: 'indexType',
  innerDataType: 'innerDataType',
  isNullable: 'isNullable',
  lookupColumnGroupId: 'lookupColumnGroupId',
  organizationId: 'organizationId',
  physicalName: 'physicalName',
  stableColumnId: 'stableColumnId',
  stableColumnName: 'stableColumnName',
  stableColumnSlug: 'stableColumnSlug',
  stableLookupColumnId: 'stableLookupColumnId',
  stableLookupTableColumnGroupId: 'stableLookupTableColumnGroupId',
  stableLookupTableId: 'stableLookupTableId',
  stableTableId: 'stableTableId',
  stableTableName: 'stableTableName',
  stableTableSlug: 'stableTableSlug',
  storageType: 'storageType',
  tableId: 'tableId',
  tableColumnId: 'tableColumnId',
  versionNumber: 'versionNumber',
} as const

export type TableColumnVersionScalarFieldEnum =
  (typeof TableColumnVersionScalarFieldEnum)[keyof typeof TableColumnVersionScalarFieldEnum]

export const TableExportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  backend: 'backend',
  createdById: 'createdById',
  documentId: 'documentId',
  errorMessage: 'errorMessage',
  exportConfig: 'exportConfig',
  fileName: 'fileName',
  organizationExportId: 'organizationExportId',
  rowCount: 'rowCount',
  status: 'status',
  tableId: 'tableId',
} as const

export type TableExportScalarFieldEnum =
  (typeof TableExportScalarFieldEnum)[keyof typeof TableExportScalarFieldEnum]

export const TableRowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  parentRowId: 'parentRowId',
  processingWorkspaceButtonId: 'processingWorkspaceButtonId',
  rootWorkspaceId: 'rootWorkspaceId',
  tableId: 'tableId',
  updatedById: 'updatedById',
} as const

export type TableRowScalarFieldEnum =
  (typeof TableRowScalarFieldEnum)[keyof typeof TableRowScalarFieldEnum]

export const TableSchemaVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activatedAt: 'activatedAt',
  deactivatedAt: 'deactivatedAt',
  organizationId: 'organizationId',
  stableTableId: 'stableTableId',
  tableId: 'tableId',
  versionNumber: 'versionNumber',
} as const

export type TableSchemaVersionScalarFieldEnum =
  (typeof TableSchemaVersionScalarFieldEnum)[keyof typeof TableSchemaVersionScalarFieldEnum]

export const TableTabScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  booleanOperator: 'booleanOperator',
  isShareable: 'isShareable',
  name: 'name',
  order: 'order',
  slug: 'slug',
  tableId: 'tableId',
} as const

export type TableTabScalarFieldEnum =
  (typeof TableTabScalarFieldEnum)[keyof typeof TableTabScalarFieldEnum]

export const TableTabColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isFrozen: 'isFrozen',
  order: 'order',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type TableTabColumnScalarFieldEnum =
  (typeof TableTabColumnScalarFieldEnum)[keyof typeof TableTabColumnScalarFieldEnum]

export const TableTabSortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  direction: 'direction',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type TableTabSortScalarFieldEnum =
  (typeof TableTabSortScalarFieldEnum)[keyof typeof TableTabSortScalarFieldEnum]

export const TableUniqueConstraintScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conflictSample: 'conflictSample',
  conflictedKeyGroupCount: 'conflictedKeyGroupCount',
  conflictsCheckedAt: 'conflictsCheckedAt',
  conflictsTruncated: 'conflictsTruncated',
  failedAttempts: 'failedAttempts',
  lastErrorCode: 'lastErrorCode',
  lastErrorMessage: 'lastErrorMessage',
  lastFailedAt: 'lastFailedAt',
  name: 'name',
  nullsDistinct: 'nullsDistinct',
  scope: 'scope',
  status: 'status',
  tableId: 'tableId',
} as const

export type TableUniqueConstraintScalarFieldEnum =
  (typeof TableUniqueConstraintScalarFieldEnum)[keyof typeof TableUniqueConstraintScalarFieldEnum]

export const TableUniqueConstraintColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  columnId: 'columnId',
  constraintId: 'constraintId',
  position: 'position',
} as const

export type TableUniqueConstraintColumnScalarFieldEnum =
  (typeof TableUniqueConstraintColumnScalarFieldEnum)[keyof typeof TableUniqueConstraintColumnScalarFieldEnum]

export const ToolRunStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agentRunId: 'agentRunId',
  completedAt: 'completedAt',
  confirmationMessage: 'confirmationMessage',
  input: 'input',
  modelSpecId: 'modelSpecId',
  output: 'output',
  status: 'status',
  toolCallId: 'toolCallId',
  toolName: 'toolName',
  userRejectionReason: 'userRejectionReason',
} as const

export type ToolRunStepScalarFieldEnum =
  (typeof ToolRunStepScalarFieldEnum)[keyof typeof ToolRunStepScalarFieldEnum]

export const TriumvirateValidationMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  actionAutoTriggerId: 'actionAutoTriggerId',
  actionStepId: 'actionStepId',
  actionStepGroupId: 'actionStepGroupId',
  message: 'message',
  type: 'type',
} as const

export type TriumvirateValidationMessageScalarFieldEnum =
  (typeof TriumvirateValidationMessageScalarFieldEnum)[keyof typeof TriumvirateValidationMessageScalarFieldEnum]

export const UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  defaultSignatureId: 'defaultSignatureId',
  email: 'email',
  externalUserId: 'externalUserId',
  firebaseUid: 'firebaseUid',
  firstName: 'firstName',
  isRobopmoAccount: 'isRobopmoAccount',
  lastName: 'lastName',
  locale: 'locale',
  organizationId: 'organizationId',
  orientation: 'orientation',
  phoneNumber: 'phoneNumber',
  policiesAcceptedAt: 'policiesAcceptedAt',
  profilePictureId: 'profilePictureId',
  status: 'status',
  timeZone: 'timeZone',
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]

export const ViewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chartId: 'chartId',
  documentId: 'documentId',
  embedId: 'embedId',
  formV2Id: 'formV2Id',
  order: 'order',
  parentWorkspaceId: 'parentWorkspaceId',
  rowNumber: 'rowNumber',
  tableId: 'tableId',
  tableRowId: 'tableRowId',
  unitHeight: 'unitHeight',
  unitWidth: 'unitWidth',
  viewableObjectType: 'viewableObjectType',
  workspaceId: 'workspaceId',
} as const

export type ViewScalarFieldEnum = (typeof ViewScalarFieldEnum)[keyof typeof ViewScalarFieldEnum]

export const ViewContentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contentType: 'contentType',
  latestVersion: 'latestVersion',
  organizationId: 'organizationId',
  slug: 'slug',
} as const

export type ViewContentScalarFieldEnum =
  (typeof ViewContentScalarFieldEnum)[keyof typeof ViewContentScalarFieldEnum]

export const ViewContentVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  endpoints: 'endpoints',
  mappings: 'mappings',
  sdkVersion: 'sdkVersion',
  sizeBytes: 'sizeBytes',
  storagePath: 'storagePath',
  version: 'version',
  viewContentId: 'viewContentId',
} as const

export type ViewContentVersionScalarFieldEnum =
  (typeof ViewContentVersionScalarFieldEnum)[keyof typeof ViewContentVersionScalarFieldEnum]

export const WorkflowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  isUserVisible: 'isUserVisible',
  name: 'name',
  organizationId: 'organizationId',
  slug: 'slug',
  status: 'status',
} as const

export type WorkflowScalarFieldEnum =
  (typeof WorkflowScalarFieldEnum)[keyof typeof WorkflowScalarFieldEnum]

export const WorkflowV2ScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  invalidReason: 'invalidReason',
  invalidatedAt: 'invalidatedAt',
  lastVerifiedAt: 'lastVerifiedAt',
  latestVersionId: 'latestVersionId',
  organizationId: 'organizationId',
  slug: 'slug',
  verificationStatus: 'verificationStatus',
} as const

export type WorkflowV2ScalarFieldEnum =
  (typeof WorkflowV2ScalarFieldEnum)[keyof typeof WorkflowV2ScalarFieldEnum]

export const WorkflowV2DiagnosticScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  code: 'code',
  entityRefs: 'entityRefs',
  message: 'message',
  severity: 'severity',
  source: 'source',
  spanColumn: 'spanColumn',
  spanEnd: 'spanEnd',
  spanFile: 'spanFile',
  spanLine: 'spanLine',
  spanStart: 'spanStart',
  workflowV2Id: 'workflowV2Id',
} as const

export type WorkflowV2DiagnosticScalarFieldEnum =
  (typeof WorkflowV2DiagnosticScalarFieldEnum)[keyof typeof WorkflowV2DiagnosticScalarFieldEnum]

export const WorkflowV2IdempotencyKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  executionId: 'executionId',
  expiresAt: 'expiresAt',
  inputHash: 'inputHash',
  key: 'key',
  status: 'status',
  workflowV2Id: 'workflowV2Id',
} as const

export type WorkflowV2IdempotencyKeyScalarFieldEnum =
  (typeof WorkflowV2IdempotencyKeyScalarFieldEnum)[keyof typeof WorkflowV2IdempotencyKeyScalarFieldEnum]

export const WorkflowV2VersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  compilerVersion: 'compilerVersion',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  engineVersion: 'engineVersion',
  mappingsHash: 'mappingsHash',
  shimHash: 'shimHash',
  shimVersion: 'shimVersion',
  sourceMapHash: 'sourceMapHash',
  version: 'version',
  workflowV2Id: 'workflowV2Id',
} as const

export type WorkflowV2VersionScalarFieldEnum =
  (typeof WorkflowV2VersionScalarFieldEnum)[keyof typeof WorkflowV2VersionScalarFieldEnum]

export const WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  name: 'name',
  order: 'order',
  organizationId: 'organizationId',
  parentOrganizationId: 'parentOrganizationId',
  slug: 'slug',
  updatedById: 'updatedById',
} as const

export type WorkspaceScalarFieldEnum =
  (typeof WorkspaceScalarFieldEnum)[keyof typeof WorkspaceScalarFieldEnum]

export const WorkspaceButtonScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  buttonConfiguration: 'buttonConfiguration',
  buttonNodeId: 'buttonNodeId',
  confirmationMessage: 'confirmationMessage',
  formId: 'formId',
  formV2Id: 'formV2Id',
  formVariantId: 'formVariantId',
  iconId: 'iconId',
  manualTriggerId: 'manualTriggerId',
  name: 'name',
  order: 'order',
  parentWorkspaceId: 'parentWorkspaceId',
  requiresConfirmation: 'requiresConfirmation',
} as const

export type WorkspaceButtonScalarFieldEnum =
  (typeof WorkspaceButtonScalarFieldEnum)[keyof typeof WorkspaceButtonScalarFieldEnum]

export const WorkspaceChildParentEdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parentWorkspaceId: 'parentWorkspaceId',
  workspaceId: 'workspaceId',
} as const

export type WorkspaceChildParentEdgeScalarFieldEnum =
  (typeof WorkspaceChildParentEdgeScalarFieldEnum)[keyof typeof WorkspaceChildParentEdgeScalarFieldEnum]

export const ArchivedActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  alertSlack: 'alertSlack',
  description: 'description',
  featureFlags: 'featureFlags',
  name: 'name',
  order: 'order',
  showNotification: 'showNotification',
  slug: 'slug',
  status: 'status',
  workflowId: 'workflowId',
} as const

export type ArchivedActionScalarFieldEnum =
  (typeof ArchivedActionScalarFieldEnum)[keyof typeof ArchivedActionScalarFieldEnum]

export const ArchivedActionApiTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  organizationId: 'organizationId',
  requestSchema: 'requestSchema',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
} as const

export type ArchivedActionApiTriggerScalarFieldEnum =
  (typeof ArchivedActionApiTriggerScalarFieldEnum)[keyof typeof ArchivedActionApiTriggerScalarFieldEnum]

export const ArchivedActionAutoTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  filterExpression: 'filterExpression',
  logoId: 'logoId',
  organizationId: 'organizationId',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  triggerMetadata: 'triggerMetadata',
  type: 'type',
  workflowV2Id: 'workflowV2Id',
} as const

export type ArchivedActionAutoTriggerScalarFieldEnum =
  (typeof ArchivedActionAutoTriggerScalarFieldEnum)[keyof typeof ArchivedActionAutoTriggerScalarFieldEnum]

export const ArchivedActionDatastoreVariableScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  defaultValue: 'defaultValue',
  description: 'description',
  name: 'name',
  type: 'type',
} as const

export type ArchivedActionDatastoreVariableScalarFieldEnum =
  (typeof ArchivedActionDatastoreVariableScalarFieldEnum)[keyof typeof ArchivedActionDatastoreVariableScalarFieldEnum]

export const ArchivedActionFrequencyTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  daysOfWeek: 'daysOfWeek',
  hoursOfDay: 'hoursOfDay',
  organizationId: 'organizationId',
  repeatNumber: 'repeatNumber',
  repeatUnit: 'repeatUnit',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  startAt: 'startAt',
  workflowV2Id: 'workflowV2Id',
} as const

export type ArchivedActionFrequencyTriggerScalarFieldEnum =
  (typeof ArchivedActionFrequencyTriggerScalarFieldEnum)[keyof typeof ArchivedActionFrequencyTriggerScalarFieldEnum]

export const ArchivedActionManualTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  name: 'name',
  organizationId: 'organizationId',
  requiresSerialExecution: 'requiresSerialExecution',
  slug: 'slug',
  workflowV2Id: 'workflowV2Id',
} as const

export type ArchivedActionManualTriggerScalarFieldEnum =
  (typeof ArchivedActionManualTriggerScalarFieldEnum)[keyof typeof ArchivedActionManualTriggerScalarFieldEnum]

export const ArchivedActionStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  actionStepGroupId: 'actionStepGroupId',
  description: 'description',
  inactiveReason: 'inactiveReason',
  integrationId: 'integrationId',
  integrationIdMapping: 'integrationIdMapping',
  logoId: 'logoId',
  name: 'name',
  oldSelectionsData: 'oldSelectionsData',
  order: 'order',
  outputSchema: 'outputSchema',
  rootActionId: 'rootActionId',
  selectionsData: 'selectionsData',
  slug: 'slug',
  status: 'status',
  type: 'type',
} as const

export type ArchivedActionStepScalarFieldEnum =
  (typeof ArchivedActionStepScalarFieldEnum)[keyof typeof ArchivedActionStepScalarFieldEnum]

export const ArchivedActionStepGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  order: 'order',
  parentActionStepId: 'parentActionStepId',
  rootActionId: 'rootActionId',
  slug: 'slug',
} as const

export type ArchivedActionStepGroupScalarFieldEnum =
  (typeof ArchivedActionStepGroupScalarFieldEnum)[keyof typeof ArchivedActionStepGroupScalarFieldEnum]

export const ArchivedActionTriggerConcurrencyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionAutoTriggerId: 'actionAutoTriggerId',
  actionFrequencyTriggerId: 'actionFrequencyTriggerId',
  actionManualTriggerId: 'actionManualTriggerId',
  keyExpressions: 'keyExpressions',
  mode: 'mode',
  scope: 'scope',
} as const

export type ArchivedActionTriggerConcurrencyScalarFieldEnum =
  (typeof ArchivedActionTriggerConcurrencyScalarFieldEnum)[keyof typeof ArchivedActionTriggerConcurrencyScalarFieldEnum]

export const ArchivedAgentRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  completedAt: 'completedAt',
  dossbotChatRunId: 'dossbotChatRunId',
  input: 'input',
  modelSpecId: 'modelSpecId',
  status: 'status',
  summary: 'summary',
  systemPromptId: 'systemPromptId',
  tokenUsage: 'tokenUsage',
} as const

export type ArchivedAgentRunScalarFieldEnum =
  (typeof ArchivedAgentRunScalarFieldEnum)[keyof typeof ArchivedAgentRunScalarFieldEnum]

export const ArchivedChartScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  aggregationOperation: 'aggregationOperation',
  chartType: 'chartType',
  filtersBooleanOperator: 'filtersBooleanOperator',
  name: 'name',
  organizationId: 'organizationId',
  rootWorkspaceId: 'rootWorkspaceId',
  slug: 'slug',
  styling: 'styling',
  tableId: 'tableId',
  thresholds: 'thresholds',
  xAxisId: 'xAxisId',
  yAxisId: 'yAxisId',
} as const

export type ArchivedChartScalarFieldEnum =
  (typeof ArchivedChartScalarFieldEnum)[keyof typeof ArchivedChartScalarFieldEnum]

export const ArchivedChartAggregationColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  aggregationOperation: 'aggregationOperation',
  chartId: 'chartId',
  order: 'order',
  tableColumnId: 'tableColumnId',
  valueDisplayType: 'valueDisplayType',
} as const

export type ArchivedChartAggregationColumnScalarFieldEnum =
  (typeof ArchivedChartAggregationColumnScalarFieldEnum)[keyof typeof ArchivedChartAggregationColumnScalarFieldEnum]

export const ArchivedChartGroupByScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  chartId: 'chartId',
  metadata: 'metadata',
  tableColumnId: 'tableColumnId',
  type: 'type',
} as const

export type ArchivedChartGroupByScalarFieldEnum =
  (typeof ArchivedChartGroupByScalarFieldEnum)[keyof typeof ArchivedChartGroupByScalarFieldEnum]

export const ArchivedChartGroupBySortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  aggregationColumnId: 'aggregationColumnId',
  direction: 'direction',
  groupById: 'groupById',
  sortType: 'sortType',
} as const

export type ArchivedChartGroupBySortScalarFieldEnum =
  (typeof ArchivedChartGroupBySortScalarFieldEnum)[keyof typeof ArchivedChartGroupBySortScalarFieldEnum]

export const ArchivedCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  authorId: 'authorId',
  parentCommentId: 'parentCommentId',
  text: 'text',
  workspaceId: 'workspaceId',
} as const

export type ArchivedCommentScalarFieldEnum =
  (typeof ArchivedCommentScalarFieldEnum)[keyof typeof ArchivedCommentScalarFieldEnum]

export const ArchivedDocumentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  contentSha256: 'contentSha256',
  contentSizeBytes: 'contentSizeBytes',
  createdById: 'createdById',
  documentType: 'documentType',
  markForDeletionAt: 'markForDeletionAt',
  name: 'name',
  organizationId: 'organizationId',
  rootWorkspaceId: 'rootWorkspaceId',
  storagePath: 'storagePath',
  updatedById: 'updatedById',
} as const

export type ArchivedDocumentScalarFieldEnum =
  (typeof ArchivedDocumentScalarFieldEnum)[keyof typeof ArchivedDocumentScalarFieldEnum]

export const ArchivedDossbotChatScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdById: 'createdById',
  summary: 'summary',
  title: 'title',
} as const

export type ArchivedDossbotChatScalarFieldEnum =
  (typeof ArchivedDossbotChatScalarFieldEnum)[keyof typeof ArchivedDossbotChatScalarFieldEnum]

export const ArchivedDossbotChatRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  chatId: 'chatId',
  completedAt: 'completedAt',
  inputPrompt: 'inputPrompt',
  response: 'response',
  status: 'status',
} as const

export type ArchivedDossbotChatRunScalarFieldEnum =
  (typeof ArchivedDossbotChatRunScalarFieldEnum)[keyof typeof ArchivedDossbotChatRunScalarFieldEnum]

export const ArchivedDossbotEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  agentRunId: 'agentRunId',
  chatId: 'chatId',
  chatRunId: 'chatRunId',
  payload: 'payload',
  toolRunStepId: 'toolRunStepId',
  type: 'type',
} as const

export type ArchivedDossbotEventScalarFieldEnum =
  (typeof ArchivedDossbotEventScalarFieldEnum)[keyof typeof ArchivedDossbotEventScalarFieldEnum]

export const ArchivedEdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  sourceNodeId: 'sourceNodeId',
  targetNodeId: 'targetNodeId',
} as const

export type ArchivedEdgeScalarFieldEnum =
  (typeof ArchivedEdgeScalarFieldEnum)[keyof typeof ArchivedEdgeScalarFieldEnum]

export const ArchivedEmbedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  betaWatermarkDisabled: 'betaWatermarkDisabled',
  name: 'name',
  organizationId: 'organizationId',
  viewContentId: 'viewContentId',
} as const

export type ArchivedEmbedScalarFieldEnum =
  (typeof ArchivedEmbedScalarFieldEnum)[keyof typeof ArchivedEmbedScalarFieldEnum]

export const ArchivedEndpointScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  enabled: 'enabled',
  internal: 'internal',
  latestVersionId: 'latestVersionId',
  organizationId: 'organizationId',
  slug: 'slug',
} as const

export type ArchivedEndpointScalarFieldEnum =
  (typeof ArchivedEndpointScalarFieldEnum)[keyof typeof ArchivedEndpointScalarFieldEnum]

export const ArchivedEndpointVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  compilerVersion: 'compilerVersion',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  endpointId: 'endpointId',
  engineVersion: 'engineVersion',
  idempotency: 'idempotency',
  input: 'input',
  manifest: 'manifest',
  mappings: 'mappings',
  mappingsHash: 'mappingsHash',
  output: 'output',
  shimHash: 'shimHash',
  shimVersion: 'shimVersion',
  sourceMapHash: 'sourceMapHash',
  version: 'version',
} as const

export type ArchivedEndpointVersionScalarFieldEnum =
  (typeof ArchivedEndpointVersionScalarFieldEnum)[keyof typeof ArchivedEndpointVersionScalarFieldEnum]

export const ArchivedEntityVersionHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  comment: 'comment',
  entityType: 'entityType',
  formV2Id: 'formV2Id',
  jsonSnapshot: 'jsonSnapshot',
  modifiedBy: 'modifiedBy',
  tableId: 'tableId',
} as const

export type ArchivedEntityVersionHistoryScalarFieldEnum =
  (typeof ArchivedEntityVersionHistoryScalarFieldEnum)[keyof typeof ArchivedEntityVersionHistoryScalarFieldEnum]

export const ArchivedEnumOptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  colorCustom: 'colorCustom',
  colorPreset: 'colorPreset',
  enumSetId: 'enumSetId',
  iconId: 'iconId',
  label: 'label',
  order: 'order',
} as const

export type ArchivedEnumOptionScalarFieldEnum =
  (typeof ArchivedEnumOptionScalarFieldEnum)[keyof typeof ArchivedEnumOptionScalarFieldEnum]

export const ArchivedEnumSetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  organizationId: 'organizationId',
} as const

export type ArchivedEnumSetScalarFieldEnum =
  (typeof ArchivedEnumSetScalarFieldEnum)[keyof typeof ArchivedEnumSetScalarFieldEnum]

export const ArchivedEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdById: 'createdById',
  data: 'data',
  type: 'type',
  workspaceId: 'workspaceId',
} as const

export type ArchivedEventScalarFieldEnum =
  (typeof ArchivedEventScalarFieldEnum)[keyof typeof ArchivedEventScalarFieldEnum]

export const ArchivedFormScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  isShareable: 'isShareable',
  name: 'name',
  organizationId: 'organizationId',
  redirectCustomPath: 'redirectCustomPath',
  redirectTarget: 'redirectTarget',
  slug: 'slug',
} as const

export type ArchivedFormScalarFieldEnum =
  (typeof ArchivedFormScalarFieldEnum)[keyof typeof ArchivedFormScalarFieldEnum]

export const ArchivedFormBlockScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formId: 'formId',
  inputId: 'inputId',
  inputGroupId: 'inputGroupId',
  metadata: 'metadata',
  order: 'order',
  parentBlockId: 'parentBlockId',
  type: 'type',
} as const

export type ArchivedFormBlockScalarFieldEnum =
  (typeof ArchivedFormBlockScalarFieldEnum)[keyof typeof ArchivedFormBlockScalarFieldEnum]

export const ArchivedFormCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  allowFillAll: 'allowFillAll',
  formId: 'formId',
  isArray: 'isArray',
  lookupTableId: 'lookupTableId',
  name: 'name',
  order: 'order',
  pageId: 'pageId',
  slug: 'slug',
} as const

export type ArchivedFormCategoryScalarFieldEnum =
  (typeof ArchivedFormCategoryScalarFieldEnum)[keyof typeof ArchivedFormCategoryScalarFieldEnum]

export const ArchivedFormFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  categoryId: 'categoryId',
  defaultValue: 'defaultValue',
  description: 'description',
  displayImagesInline: 'displayImagesInline',
  fieldOptions: 'fieldOptions',
  formId: 'formId',
  isArray: 'isArray',
  isEditable: 'isEditable',
  isFrozen: 'isFrozen',
  isRequired: 'isRequired',
  isVisible: 'isVisible',
  lookupColumnId: 'lookupColumnId',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  metadata: 'metadata',
  name: 'name',
  order: 'order',
  slug: 'slug',
  type: 'type',
} as const

export type ArchivedFormFieldScalarFieldEnum =
  (typeof ArchivedFormFieldScalarFieldEnum)[keyof typeof ArchivedFormFieldScalarFieldEnum]

export const ArchivedFormFileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formId: 'formId',
  formCategoryId: 'formCategoryId',
  nameFieldId: 'nameFieldId',
  type: 'type',
} as const

export type ArchivedFormFileScalarFieldEnum =
  (typeof ArchivedFormFileScalarFieldEnum)[keyof typeof ArchivedFormFileScalarFieldEnum]

export const ArchivedFormInputScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  dataType: 'dataType',
  defaultValue: 'defaultValue',
  description: 'description',
  formId: 'formId',
  formatOptions: 'formatOptions',
  formatPreset: 'formatPreset',
  formulaId: 'formulaId',
  groupId: 'groupId',
  indexDataType: 'indexDataType',
  innerDataType: 'innerDataType',
  inputType: 'inputType',
  isFrozen: 'isFrozen',
  isReadOnly: 'isReadOnly',
  isRequired: 'isRequired',
  isVisible: 'isVisible',
  label: 'label',
  lookupGroupId: 'lookupGroupId',
  lookupTableColumnId: 'lookupTableColumnId',
  metadata: 'metadata',
  slug: 'slug',
  sourceTableColumnId: 'sourceTableColumnId',
} as const

export type ArchivedFormInputScalarFieldEnum =
  (typeof ArchivedFormInputScalarFieldEnum)[keyof typeof ArchivedFormInputScalarFieldEnum]

export const ArchivedFormInputGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formId: 'formId',
  label: 'label',
  slug: 'slug',
} as const

export type ArchivedFormInputGroupScalarFieldEnum =
  (typeof ArchivedFormInputGroupScalarFieldEnum)[keyof typeof ArchivedFormInputGroupScalarFieldEnum]

export const ArchivedFormLookupInputGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formId: 'formId',
  isAutoFill: 'isAutoFill',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  lookupTableId: 'lookupTableId',
} as const

export type ArchivedFormLookupInputGroupScalarFieldEnum =
  (typeof ArchivedFormLookupInputGroupScalarFieldEnum)[keyof typeof ArchivedFormLookupInputGroupScalarFieldEnum]

export const ArchivedFormPageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formId: 'formId',
  name: 'name',
  order: 'order',
  slug: 'slug',
} as const

export type ArchivedFormPageScalarFieldEnum =
  (typeof ArchivedFormPageScalarFieldEnum)[keyof typeof ArchivedFormPageScalarFieldEnum]

export const ArchivedFormV2ScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  linkedTableId: 'linkedTableId',
  name: 'name',
  organizationId: 'organizationId',
  redirectCustomPath: 'redirectCustomPath',
  redirectTarget: 'redirectTarget',
  slug: 'slug',
  sourceFormId: 'sourceFormId',
} as const

export type ArchivedFormV2ScalarFieldEnum =
  (typeof ArchivedFormV2ScalarFieldEnum)[keyof typeof ArchivedFormV2ScalarFieldEnum]

export const ArchivedFormValidationConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  conditionExpressionId: 'conditionExpressionId',
  inputAppliedToId: 'inputAppliedToId',
  validationMessage: 'validationMessage',
} as const

export type ArchivedFormValidationConditionScalarFieldEnum =
  (typeof ArchivedFormValidationConditionScalarFieldEnum)[keyof typeof ArchivedFormValidationConditionScalarFieldEnum]

export const ArchivedFormVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  formId: 'formId',
  name: 'name',
} as const

export type ArchivedFormVariantScalarFieldEnum =
  (typeof ArchivedFormVariantScalarFieldEnum)[keyof typeof ArchivedFormVariantScalarFieldEnum]

export const ArchivedFormVariantInputScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  defaultValue: 'defaultValue',
  inputId: 'inputId',
  isReadOnly: 'isReadOnly',
  variantId: 'variantId',
} as const

export type ArchivedFormVariantInputScalarFieldEnum =
  (typeof ArchivedFormVariantInputScalarFieldEnum)[keyof typeof ArchivedFormVariantInputScalarFieldEnum]

export const Archived_ConditionallyVisibleFormBlocksScalarFieldEnum = {
  A: 'A',
  B: 'B',
  deletedAt: 'deletedAt',
} as const

export type Archived_ConditionallyVisibleFormBlocksScalarFieldEnum =
  (typeof Archived_ConditionallyVisibleFormBlocksScalarFieldEnum)[keyof typeof Archived_ConditionallyVisibleFormBlocksScalarFieldEnum]

export const ArchivedFormVisibilityConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  expressionId: 'expressionId',
  formV2Id: 'formV2Id',
  name: 'name',
  slug: 'slug',
} as const

export type ArchivedFormVisibilityConditionScalarFieldEnum =
  (typeof ArchivedFormVisibilityConditionScalarFieldEnum)[keyof typeof ArchivedFormVisibilityConditionScalarFieldEnum]

export const ArchivedFormulaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  columnOperationFilterId: 'columnOperationFilterId',
  formulaString: 'formulaString',
  operator: 'operator',
  organizationId: 'organizationId',
  outputType: 'outputType',
} as const

export type ArchivedFormulaScalarFieldEnum =
  (typeof ArchivedFormulaScalarFieldEnum)[keyof typeof ArchivedFormulaScalarFieldEnum]

export const ArchivedFormulaConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  conditionExpressionId: 'conditionExpressionId',
  formulaId: 'formulaId',
  order: 'order',
  parentFormulaValueId: 'parentFormulaValueId',
} as const

export type ArchivedFormulaConditionScalarFieldEnum =
  (typeof ArchivedFormulaConditionScalarFieldEnum)[keyof typeof ArchivedFormulaConditionScalarFieldEnum]

export const ArchivedFormulaValueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  formInputId: 'formInputId',
  formulaId: 'formulaId',
  order: 'order',
  parentFormulaId: 'parentFormulaId',
  tableColumnId: 'tableColumnId',
  valueBoolean: 'valueBoolean',
  valueDate: 'valueDate',
  valueDateTime: 'valueDateTime',
  valueNumber: 'valueNumber',
  valueString: 'valueString',
} as const

export type ArchivedFormulaValueScalarFieldEnum =
  (typeof ArchivedFormulaValueScalarFieldEnum)[keyof typeof ArchivedFormulaValueScalarFieldEnum]

export const ArchivedGeneratedFileFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  fieldName: 'fieldName',
  type: 'type',
} as const

export type ArchivedGeneratedFileFieldScalarFieldEnum =
  (typeof ArchivedGeneratedFileFieldScalarFieldEnum)[keyof typeof ArchivedGeneratedFileFieldScalarFieldEnum]

export const ArchivedGeneratedFileFieldMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  fileFieldId: 'fileFieldId',
  formFieldId: 'formFieldId',
  formFileId: 'formFileId',
} as const

export type ArchivedGeneratedFileFieldMappingScalarFieldEnum =
  (typeof ArchivedGeneratedFileFieldMappingScalarFieldEnum)[keyof typeof ArchivedGeneratedFileFieldMappingScalarFieldEnum]

export const ArchivedIconScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
} as const

export type ArchivedIconScalarFieldEnum =
  (typeof ArchivedIconScalarFieldEnum)[keyof typeof ArchivedIconScalarFieldEnum]

export const ArchivedIntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  metadata: 'metadata',
  organizationId: 'organizationId',
  slug: 'slug',
  type: 'type',
  userId: 'userId',
} as const

export type ArchivedIntegrationScalarFieldEnum =
  (typeof ArchivedIntegrationScalarFieldEnum)[keyof typeof ArchivedIntegrationScalarFieldEnum]

export const ArchivedIntegrationSyncScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  integrationId: 'integrationId',
  metadata: 'metadata',
  status: 'status',
} as const

export type ArchivedIntegrationSyncScalarFieldEnum =
  (typeof ArchivedIntegrationSyncScalarFieldEnum)[keyof typeof ArchivedIntegrationSyncScalarFieldEnum]

export const ArchivedLogicExpressionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  condition: 'condition',
  logicExpressionString: 'logicExpressionString',
  type: 'type',
} as const

export type ArchivedLogicExpressionScalarFieldEnum =
  (typeof ArchivedLogicExpressionScalarFieldEnum)[keyof typeof ArchivedLogicExpressionScalarFieldEnum]

export const ArchivedLogicExpressionValueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  columnId: 'columnId',
  formFieldId: 'formFieldId',
  formInputId: 'formInputId',
  formulaId: 'formulaId',
  nestedExpressionId: 'nestedExpressionId',
  order: 'order',
  parentExpressionId: 'parentExpressionId',
  value: 'value',
} as const

export type ArchivedLogicExpressionValueScalarFieldEnum =
  (typeof ArchivedLogicExpressionValueScalarFieldEnum)[keyof typeof ArchivedLogicExpressionValueScalarFieldEnum]

export const ArchivedLookupTableColumnGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  backlinkName: 'backlinkName',
  lookupTableId: 'lookupTableId',
  showBacklink: 'showBacklink',
  slug: 'slug',
} as const

export type ArchivedLookupTableColumnGroupScalarFieldEnum =
  (typeof ArchivedLookupTableColumnGroupScalarFieldEnum)[keyof typeof ArchivedLookupTableColumnGroupScalarFieldEnum]

export const ArchivedModelOptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  cacheReadUsdPerMtok: 'cacheReadUsdPerMtok',
  cacheWriteUsdPerMtok: 'cacheWriteUsdPerMtok',
  inputUsdPerMtok: 'inputUsdPerMtok',
  modelName: 'modelName',
  outputUsdPerMtok: 'outputUsdPerMtok',
  provider: 'provider',
} as const

export type ArchivedModelOptionScalarFieldEnum =
  (typeof ArchivedModelOptionScalarFieldEnum)[keyof typeof ArchivedModelOptionScalarFieldEnum]

export const ArchivedModelSpecificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  maxSteps: 'maxSteps',
  modelId: 'modelId',
  name: 'name',
} as const

export type ArchivedModelSpecificationScalarFieldEnum =
  (typeof ArchivedModelSpecificationScalarFieldEnum)[keyof typeof ArchivedModelSpecificationScalarFieldEnum]

export const ArchivedNavigationItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  destinationId: 'destinationId',
  destinationType: 'destinationType',
  icon: 'icon',
  label: 'label',
  link: 'link',
  order: 'order',
  organizationId: 'organizationId',
  parentItemId: 'parentItemId',
} as const

export type ArchivedNavigationItemScalarFieldEnum =
  (typeof ArchivedNavigationItemScalarFieldEnum)[keyof typeof ArchivedNavigationItemScalarFieldEnum]

export const ArchivedNodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  sourceId: 'sourceId',
  sourceType: 'sourceType',
} as const

export type ArchivedNodeScalarFieldEnum =
  (typeof ArchivedNodeScalarFieldEnum)[keyof typeof ArchivedNodeScalarFieldEnum]

export const ArchivedNotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  commentId: 'commentId',
  isArchived: 'isArchived',
  isRead: 'isRead',
  metadata: 'metadata',
  notificationType: 'notificationType',
  userId: 'userId',
} as const

export type ArchivedNotificationScalarFieldEnum =
  (typeof ArchivedNotificationScalarFieldEnum)[keyof typeof ArchivedNotificationScalarFieldEnum]

export const ArchivedObjectStoreTableSyncScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  daysOfWeek: 'daysOfWeek',
  direction: 'direction',
  filePattern: 'filePattern',
  fileType: 'fileType',
  ignoreMissingColumns: 'ignoreMissingColumns',
  integrationId: 'integrationId',
  repeatNumber: 'repeatNumber',
  repeatUnit: 'repeatUnit',
  startAt: 'startAt',
  tableId: 'tableId',
} as const

export type ArchivedObjectStoreTableSyncScalarFieldEnum =
  (typeof ArchivedObjectStoreTableSyncScalarFieldEnum)[keyof typeof ArchivedObjectStoreTableSyncScalarFieldEnum]

export const ArchivedOrganizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  currency: 'currency',
  featureFlags: 'featureFlags',
  locale: 'locale',
  logoId: 'logoId',
  name: 'name',
  navigationConfigbaseHash: 'navigationConfigbaseHash',
  parentOrganizationId: 'parentOrganizationId',
  slug: 'slug',
  startOfFiscalYearMonth: 'startOfFiscalYearMonth',
  startOfWeekDay: 'startOfWeekDay',
  status: 'status',
  timeZone: 'timeZone',
  version: 'version',
} as const

export type ArchivedOrganizationScalarFieldEnum =
  (typeof ArchivedOrganizationScalarFieldEnum)[keyof typeof ArchivedOrganizationScalarFieldEnum]

export const ArchivedPermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  embedId: 'embedId',
  endpointId: 'endpointId',
  formId: 'formId',
  formV2Id: 'formV2Id',
  manualTriggerId: 'manualTriggerId',
  objectType: 'objectType',
  permissionType: 'permissionType',
  roleId: 'roleId',
  tableId: 'tableId',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
  workspaceId: 'workspaceId',
} as const

export type ArchivedPermissionScalarFieldEnum =
  (typeof ArchivedPermissionScalarFieldEnum)[keyof typeof ArchivedPermissionScalarFieldEnum]

export const Archived_UserRolesScalarFieldEnum = {
  A: 'A',
  B: 'B',
  B_deprecated: 'B_deprecated',
  deletedAt: 'deletedAt',
} as const

export type Archived_UserRolesScalarFieldEnum =
  (typeof Archived_UserRolesScalarFieldEnum)[keyof typeof Archived_UserRolesScalarFieldEnum]

export const ArchivedRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  organizationId: 'organizationId',
  roleType: 'roleType',
  slug: 'slug',
} as const

export type ArchivedRoleScalarFieldEnum =
  (typeof ArchivedRoleScalarFieldEnum)[keyof typeof ArchivedRoleScalarFieldEnum]

export const ArchivedSignatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  signatureFileId: 'signatureFileId',
  userId: 'userId',
} as const

export type ArchivedSignatureScalarFieldEnum =
  (typeof ArchivedSignatureScalarFieldEnum)[keyof typeof ArchivedSignatureScalarFieldEnum]

export const ArchivedSystemPromptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  modelSpecId: 'modelSpecId',
  prompt: 'prompt',
  version: 'version',
} as const

export type ArchivedSystemPromptScalarFieldEnum =
  (typeof ArchivedSystemPromptScalarFieldEnum)[keyof typeof ArchivedSystemPromptScalarFieldEnum]

export const ArchivedTableScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  iconId: 'iconId',
  name: 'name',
  orderOnRecordDetails: 'orderOnRecordDetails',
  organizationId: 'organizationId',
  parentTableId: 'parentTableId',
  rootWorkspaceId: 'rootWorkspaceId',
  showRowWorkspace: 'showRowWorkspace',
  slug: 'slug',
} as const

export type ArchivedTableScalarFieldEnum =
  (typeof ArchivedTableScalarFieldEnum)[keyof typeof ArchivedTableScalarFieldEnum]

export const ArchivedTableButtonNodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  tableId: 'tableId',
} as const

export type ArchivedTableButtonNodeScalarFieldEnum =
  (typeof ArchivedTableButtonNodeScalarFieldEnum)[keyof typeof ArchivedTableButtonNodeScalarFieldEnum]

export const ArchivedTableButtonStateMachineConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  rootButtonNodeId: 'rootButtonNodeId',
  tableId: 'tableId',
} as const

export type ArchivedTableButtonStateMachineConfigScalarFieldEnum =
  (typeof ArchivedTableButtonStateMachineConfigScalarFieldEnum)[keyof typeof ArchivedTableButtonStateMachineConfigScalarFieldEnum]

export const ArchivedTableButtonTransitionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  conditionId: 'conditionId',
  name: 'name',
  sourceNodeId: 'sourceNodeId',
  targetNodeId: 'targetNodeId',
} as const

export type ArchivedTableButtonTransitionScalarFieldEnum =
  (typeof ArchivedTableButtonTransitionScalarFieldEnum)[keyof typeof ArchivedTableButtonTransitionScalarFieldEnum]

export const ArchivedTableButtonTransitionHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  actionId: 'actionId',
  fromNodeId: 'fromNodeId',
  fromNodeName: 'fromNodeName',
  logicExpressionString: 'logicExpressionString',
  tableRowId: 'tableRowId',
  toNodeId: 'toNodeId',
  toNodeName: 'toNodeName',
  transitionId: 'transitionId',
  userId: 'userId',
} as const

export type ArchivedTableButtonTransitionHistoryScalarFieldEnum =
  (typeof ArchivedTableButtonTransitionHistoryScalarFieldEnum)[keyof typeof ArchivedTableButtonTransitionHistoryScalarFieldEnum]

export const ArchivedTableColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  displayImagesInline: 'displayImagesInline',
  enumOptions: 'enumOptions',
  enumSetId: 'enumSetId',
  formatOptions: 'formatOptions',
  formatPreset: 'formatPreset',
  formulaId: 'formulaId',
  indexAutogenerate: 'indexAutogenerate',
  indexPrefix: 'indexPrefix',
  indexSuffix: 'indexSuffix',
  indexType: 'indexType',
  innerType: 'innerType',
  isDecimal: 'isDecimal',
  isNullable: 'isNullable',
  isReadOnly: 'isReadOnly',
  isVisibleOnRecordDetails: 'isVisibleOnRecordDetails',
  lookupColumnId: 'lookupColumnId',
  lookupColumnGroupId: 'lookupColumnGroupId',
  lookupFilterExpressionId: 'lookupFilterExpressionId',
  name: 'name',
  order: 'order',
  slug: 'slug',
  tableId: 'tableId',
  type: 'type',
} as const

export type ArchivedTableColumnScalarFieldEnum =
  (typeof ArchivedTableColumnScalarFieldEnum)[keyof typeof ArchivedTableColumnScalarFieldEnum]

export const ArchivedTableColumnFilterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  chartId: 'chartId',
  filterableObjectType: 'filterableObjectType',
  operand: 'operand',
  operator: 'operator',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type ArchivedTableColumnFilterScalarFieldEnum =
  (typeof ArchivedTableColumnFilterScalarFieldEnum)[keyof typeof ArchivedTableColumnFilterScalarFieldEnum]

export const ArchivedTableColumnGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  order: 'order',
  tableId: 'tableId',
} as const

export type ArchivedTableColumnGroupScalarFieldEnum =
  (typeof ArchivedTableColumnGroupScalarFieldEnum)[keyof typeof ArchivedTableColumnGroupScalarFieldEnum]

export const ArchivedTableColumnGroupMemberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  order: 'order',
  tableColumnId: 'tableColumnId',
  tableColumnGroupId: 'tableColumnGroupId',
} as const

export type ArchivedTableColumnGroupMemberScalarFieldEnum =
  (typeof ArchivedTableColumnGroupMemberScalarFieldEnum)[keyof typeof ArchivedTableColumnGroupMemberScalarFieldEnum]

export const Archived_RowCurrentButtonNodesScalarFieldEnum = {
  A: 'A',
  B: 'B',
  deletedAt: 'deletedAt',
} as const

export type Archived_RowCurrentButtonNodesScalarFieldEnum =
  (typeof Archived_RowCurrentButtonNodesScalarFieldEnum)[keyof typeof Archived_RowCurrentButtonNodesScalarFieldEnum]

export const Archived_RowPendingButtonNodesScalarFieldEnum = {
  A: 'A',
  B: 'B',
  deletedAt: 'deletedAt',
} as const

export type Archived_RowPendingButtonNodesScalarFieldEnum =
  (typeof Archived_RowPendingButtonNodesScalarFieldEnum)[keyof typeof Archived_RowPendingButtonNodesScalarFieldEnum]

export const ArchivedTableRowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdById: 'createdById',
  parentRowId: 'parentRowId',
  processingWorkspaceButtonId: 'processingWorkspaceButtonId',
  rootWorkspaceId: 'rootWorkspaceId',
  tableId: 'tableId',
  updatedById: 'updatedById',
} as const

export type ArchivedTableRowScalarFieldEnum =
  (typeof ArchivedTableRowScalarFieldEnum)[keyof typeof ArchivedTableRowScalarFieldEnum]

export const ArchivedTableTabScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  booleanOperator: 'booleanOperator',
  isShareable: 'isShareable',
  name: 'name',
  order: 'order',
  slug: 'slug',
  tableId: 'tableId',
} as const

export type ArchivedTableTabScalarFieldEnum =
  (typeof ArchivedTableTabScalarFieldEnum)[keyof typeof ArchivedTableTabScalarFieldEnum]

export const ArchivedTableTabColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  isFrozen: 'isFrozen',
  order: 'order',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type ArchivedTableTabColumnScalarFieldEnum =
  (typeof ArchivedTableTabColumnScalarFieldEnum)[keyof typeof ArchivedTableTabColumnScalarFieldEnum]

export const ArchivedTableTabSortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  direction: 'direction',
  systemGeneratedColumnType: 'systemGeneratedColumnType',
  tableColumnId: 'tableColumnId',
  tableTabId: 'tableTabId',
} as const

export type ArchivedTableTabSortScalarFieldEnum =
  (typeof ArchivedTableTabSortScalarFieldEnum)[keyof typeof ArchivedTableTabSortScalarFieldEnum]

export const ArchivedTableUniqueConstraintScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  conflictSample: 'conflictSample',
  conflictedKeyGroupCount: 'conflictedKeyGroupCount',
  conflictsCheckedAt: 'conflictsCheckedAt',
  conflictsTruncated: 'conflictsTruncated',
  failedAttempts: 'failedAttempts',
  lastErrorCode: 'lastErrorCode',
  lastErrorMessage: 'lastErrorMessage',
  lastFailedAt: 'lastFailedAt',
  name: 'name',
  nullsDistinct: 'nullsDistinct',
  scope: 'scope',
  status: 'status',
  tableId: 'tableId',
} as const

export type ArchivedTableUniqueConstraintScalarFieldEnum =
  (typeof ArchivedTableUniqueConstraintScalarFieldEnum)[keyof typeof ArchivedTableUniqueConstraintScalarFieldEnum]

export const ArchivedTableUniqueConstraintColumnScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  columnId: 'columnId',
  constraintId: 'constraintId',
  position: 'position',
} as const

export type ArchivedTableUniqueConstraintColumnScalarFieldEnum =
  (typeof ArchivedTableUniqueConstraintColumnScalarFieldEnum)[keyof typeof ArchivedTableUniqueConstraintColumnScalarFieldEnum]

export const ArchivedToolRunStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  agentRunId: 'agentRunId',
  completedAt: 'completedAt',
  confirmationMessage: 'confirmationMessage',
  input: 'input',
  modelSpecId: 'modelSpecId',
  output: 'output',
  status: 'status',
  toolCallId: 'toolCallId',
  toolName: 'toolName',
  userRejectionReason: 'userRejectionReason',
} as const

export type ArchivedToolRunStepScalarFieldEnum =
  (typeof ArchivedToolRunStepScalarFieldEnum)[keyof typeof ArchivedToolRunStepScalarFieldEnum]

export const ArchivedUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  defaultSignatureId: 'defaultSignatureId',
  email: 'email',
  externalUserId: 'externalUserId',
  firebaseUid: 'firebaseUid',
  firstName: 'firstName',
  isRobopmoAccount: 'isRobopmoAccount',
  lastName: 'lastName',
  locale: 'locale',
  organizationId: 'organizationId',
  orientation: 'orientation',
  phoneNumber: 'phoneNumber',
  policiesAcceptedAt: 'policiesAcceptedAt',
  profilePictureId: 'profilePictureId',
  status: 'status',
  timeZone: 'timeZone',
} as const

export type ArchivedUserScalarFieldEnum =
  (typeof ArchivedUserScalarFieldEnum)[keyof typeof ArchivedUserScalarFieldEnum]

export const ArchivedViewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  chartId: 'chartId',
  documentId: 'documentId',
  embedId: 'embedId',
  formV2Id: 'formV2Id',
  order: 'order',
  parentWorkspaceId: 'parentWorkspaceId',
  rowNumber: 'rowNumber',
  tableId: 'tableId',
  tableRowId: 'tableRowId',
  unitHeight: 'unitHeight',
  unitWidth: 'unitWidth',
  viewableObjectType: 'viewableObjectType',
  workspaceId: 'workspaceId',
} as const

export type ArchivedViewScalarFieldEnum =
  (typeof ArchivedViewScalarFieldEnum)[keyof typeof ArchivedViewScalarFieldEnum]

export const ArchivedViewContentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  contentType: 'contentType',
  latestVersion: 'latestVersion',
  organizationId: 'organizationId',
  slug: 'slug',
} as const

export type ArchivedViewContentScalarFieldEnum =
  (typeof ArchivedViewContentScalarFieldEnum)[keyof typeof ArchivedViewContentScalarFieldEnum]

export const ArchivedViewContentVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  endpoints: 'endpoints',
  mappings: 'mappings',
  sdkVersion: 'sdkVersion',
  sizeBytes: 'sizeBytes',
  storagePath: 'storagePath',
  version: 'version',
  viewContentId: 'viewContentId',
} as const

export type ArchivedViewContentVersionScalarFieldEnum =
  (typeof ArchivedViewContentVersionScalarFieldEnum)[keyof typeof ArchivedViewContentVersionScalarFieldEnum]

export const ArchivedWorkflowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  isUserVisible: 'isUserVisible',
  name: 'name',
  organizationId: 'organizationId',
  slug: 'slug',
  status: 'status',
} as const

export type ArchivedWorkflowScalarFieldEnum =
  (typeof ArchivedWorkflowScalarFieldEnum)[keyof typeof ArchivedWorkflowScalarFieldEnum]

export const ArchivedWorkflowV2ScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  enabled: 'enabled',
  invalidReason: 'invalidReason',
  invalidatedAt: 'invalidatedAt',
  lastVerifiedAt: 'lastVerifiedAt',
  latestVersionId: 'latestVersionId',
  organizationId: 'organizationId',
  slug: 'slug',
  verificationStatus: 'verificationStatus',
} as const

export type ArchivedWorkflowV2ScalarFieldEnum =
  (typeof ArchivedWorkflowV2ScalarFieldEnum)[keyof typeof ArchivedWorkflowV2ScalarFieldEnum]

export const ArchivedWorkflowV2DiagnosticScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  code: 'code',
  entityRefs: 'entityRefs',
  message: 'message',
  severity: 'severity',
  source: 'source',
  spanColumn: 'spanColumn',
  spanEnd: 'spanEnd',
  spanFile: 'spanFile',
  spanLine: 'spanLine',
  spanStart: 'spanStart',
  workflowV2Id: 'workflowV2Id',
} as const

export type ArchivedWorkflowV2DiagnosticScalarFieldEnum =
  (typeof ArchivedWorkflowV2DiagnosticScalarFieldEnum)[keyof typeof ArchivedWorkflowV2DiagnosticScalarFieldEnum]

export const ArchivedWorkflowV2VersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  compilerVersion: 'compilerVersion',
  configbaseHash: 'configbaseHash',
  contentHash: 'contentHash',
  createdById: 'createdById',
  engineVersion: 'engineVersion',
  mappingsHash: 'mappingsHash',
  shimHash: 'shimHash',
  shimVersion: 'shimVersion',
  sourceMapHash: 'sourceMapHash',
  version: 'version',
  workflowV2Id: 'workflowV2Id',
} as const

export type ArchivedWorkflowV2VersionScalarFieldEnum =
  (typeof ArchivedWorkflowV2VersionScalarFieldEnum)[keyof typeof ArchivedWorkflowV2VersionScalarFieldEnum]

export const ArchivedWorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdById: 'createdById',
  name: 'name',
  order: 'order',
  organizationId: 'organizationId',
  parentOrganizationId: 'parentOrganizationId',
  slug: 'slug',
  updatedById: 'updatedById',
} as const

export type ArchivedWorkspaceScalarFieldEnum =
  (typeof ArchivedWorkspaceScalarFieldEnum)[keyof typeof ArchivedWorkspaceScalarFieldEnum]

export const ArchivedWorkspaceButtonScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  buttonConfiguration: 'buttonConfiguration',
  buttonNodeId: 'buttonNodeId',
  confirmationMessage: 'confirmationMessage',
  formId: 'formId',
  formV2Id: 'formV2Id',
  formVariantId: 'formVariantId',
  iconId: 'iconId',
  manualTriggerId: 'manualTriggerId',
  name: 'name',
  order: 'order',
  parentWorkspaceId: 'parentWorkspaceId',
  requiresConfirmation: 'requiresConfirmation',
} as const

export type ArchivedWorkspaceButtonScalarFieldEnum =
  (typeof ArchivedWorkspaceButtonScalarFieldEnum)[keyof typeof ArchivedWorkspaceButtonScalarFieldEnum]

export const ArchivedWorkspaceChildParentEdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  parentWorkspaceId: 'parentWorkspaceId',
  workspaceId: 'workspaceId',
} as const

export type ArchivedWorkspaceChildParentEdgeScalarFieldEnum =
  (typeof ArchivedWorkspaceChildParentEdgeScalarFieldEnum)[keyof typeof ArchivedWorkspaceChildParentEdgeScalarFieldEnum]

export const ActionFrequencyScheduleReconciliationScalarFieldEnum = {
  actionId: 'actionId',
  organizationId: 'organizationId',
  nextAttemptAt: 'nextAttemptAt',
} as const

export type ActionFrequencyScheduleReconciliationScalarFieldEnum =
  (typeof ActionFrequencyScheduleReconciliationScalarFieldEnum)[keyof typeof ActionFrequencyScheduleReconciliationScalarFieldEnum]

export const IntegrationCredentialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  integrationId: 'integrationId',
  initializationVector: 'initializationVector',
  encryptedPassword: 'encryptedPassword',
  username: 'username',
  metadata: 'metadata',
} as const

export type IntegrationCredentialScalarFieldEnum =
  (typeof IntegrationCredentialScalarFieldEnum)[keyof typeof IntegrationCredentialScalarFieldEnum]

export const OrganizationApiKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  initializationVector: 'initializationVector',
  encryptedApiKey: 'encryptedApiKey',
} as const

export type OrganizationApiKeyScalarFieldEnum =
  (typeof OrganizationApiKeyScalarFieldEnum)[keyof typeof OrganizationApiKeyScalarFieldEnum]

export const AdminOAuth2TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorizationCode: 'authorizationCode',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  redirectUri: 'redirectUri',
  adminUserId: 'adminUserId',
  initializationVector: 'initializationVector',
  encryptedTokens: 'encryptedTokens',
  status: 'status',
  authCodeExpiresAt: 'authCodeExpiresAt',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  lastUsedAt: 'lastUsedAt',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
} as const

export type AdminOAuth2TokenScalarFieldEnum =
  (typeof AdminOAuth2TokenScalarFieldEnum)[keyof typeof AdminOAuth2TokenScalarFieldEnum]

export const AppOAuth2TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorizationCode: 'authorizationCode',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  redirectUri: 'redirectUri',
  userId: 'userId',
  organizationId: 'organizationId',
  initializationVector: 'initializationVector',
  encryptedTokens: 'encryptedTokens',
  status: 'status',
  authCodeExpiresAt: 'authCodeExpiresAt',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  lastUsedAt: 'lastUsedAt',
  state: 'state',
  authorizedByEmail: 'authorizedByEmail',
} as const

export type AppOAuth2TokenScalarFieldEnum =
  (typeof AppOAuth2TokenScalarFieldEnum)[keyof typeof AppOAuth2TokenScalarFieldEnum]

export const RestatePausedInvocationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invocationId: 'invocationId',
  serviceName: 'serviceName',
  handlerName: 'handlerName',
  serviceKey: 'serviceKey',
  pausedAt: 'pausedAt',
} as const

export type RestatePausedInvocationScalarFieldEnum =
  (typeof RestatePausedInvocationScalarFieldEnum)[keyof typeof RestatePausedInvocationScalarFieldEnum]

export const SortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]

export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull,
} as const

export type NullableJsonNullValueInput =
  (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]

export const JsonNullValueInput = {
  JsonNull: JsonNull,
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]

export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive',
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]

export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull,
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

export const NullsOrder = {
  first: 'first',
  last: 'last',
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]
